import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { BENEFITS, buildWhatsAppLink } from "@/lib/constants";
import { MessageCircle } from "lucide-react";

const Benefits = () => {
  return (
    <section id="vorteile" data-testid="benefits-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center"
        >
          <div className="lg:col-span-5">
            <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#1FA3B5] mb-4">Ihr Nutzen</p>
            <h2 className="font-heading text-4xl lg:text-5xl font-bold text-slate-900 leading-[1.1]">
              Das bringt Ihnen<br />
              <span className="text-[#1FA3B5]">AutoCoach konkret.</span>
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Sie zahlen einen fairen Festpreis – und sparen sich Stress, Zeit und vor allem die teuren Nachzahlungen Ihres Leasinggebers.
            </p>
            <a
              href={buildWhatsAppLink("Hallo AutoCoach, ich möchte mehr über Ihre Leistungen erfahren.")}
              target="_blank"
              rel="noreferrer"
              data-testid="benefits-cta"
              className="mt-8 inline-flex items-center gap-2 bg-[#1FA3B5] text-white rounded-full px-7 py-3.5 font-semibold hover:bg-[#178A9A] hover:-translate-y-0.5 transition-all shadow-lg shadow-[#1FA3B5]/25"
            >
              <MessageCircle className="w-5 h-5" /> Kostenlos beraten lassen
            </a>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-4">
              {BENEFITS.map((b, i) => (
                <motion.li
                  key={b}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.06 }}
                  data-testid={`benefit-${i}`}
                  className="flex items-start gap-4 p-5 rounded-2xl bg-[#F8FAFC] border border-slate-100 hover:border-[#1FA3B5]/30 hover:bg-white hover:shadow-lg transition-all"
                >
                  <CheckCircle2 className="w-6 h-6 text-[#1FA3B5] flex-shrink-0 mt-0.5" />
                  <span className="font-heading font-semibold text-slate-900">{b}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
